const videoEnhancer = {
  HitPawOnlineAIVideoEnhance: 'HitPaw Online AI Video Enhance',
  ProcessingLimit: '処理制限：{{num}}',
  AllModelsAreAvailable: 'すべてのモデルが利用できる',
  SupportAllSubdivisionRateExport: 'すべての解像度のエクスポートをサポート',
  SupportPreviewVideo: '動画のプレビューをサポート',
  BatchProcessingComingSoon: '一括処理（まもなく登場）',
  CancelAnytime: 'いつでも解約可能',
  highPriorityProcessingSpeed: '優先度の高い処理速度',
  YearDayPrice: '¥64',
  YearTotalPrice: '¥23,299',
  MonthTotalPrice: '¥3,299',
  MonthDayPrice: '¥110',
  WeekTotalPrice: '¥1,299',
  WeekDayPrice: '¥186',
  Day: '日',
  Monthly: '月',
  Weekly: '週',
  Yearly: '年',
};

export default videoEnhancer;
